import "./src/styles/global.css";
import React from "react";
import { ThemeProvider } from "@material-tailwind/react";

export const wrapRootElement = ({ element }) => (
  <ThemeProvider>{element}</ThemeProvider>
);
